import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ActionType } from "./actions.js";
import { addIndexColumnAction, changeIndexColumnOrderTypeAction, moveIndexColumnAction, removeIndexColumnAction } from "./atom.actions.js";
//#region src/engine/modules/index-column/history.ts
var addIndexColumn = (undoActions, { payload: { id, indexId, tableId } }) => {
	undoActions.push(removeIndexColumnAction({
		id,
		indexId,
		tableId
	}));
};
var removeIndexColumn = (undoActions, { payload: { id, indexId, tableId } }, { collections }) => {
	const indexColumn = query(collections).collection("indexColumnEntities").selectById(id);
	if (!indexColumn) return;
	undoActions.push(addIndexColumnAction({
		id,
		indexId,
		tableId,
		columnId: indexColumn.columnId
	}));
};
var moveIndexColumn = (undoActions, { payload: { id, indexId, tableId, targetId } }, { collections }) => {
	const index = query(collections).collection("indexEntities").selectById(indexId);
	if (!index) return;
	const i = index.indexColumnIds.indexOf(id);
	if (i === -1) return;
	const targetIndex = index.indexColumnIds.indexOf(targetId);
	if (targetIndex === -1) return;
	const revertIndex = i < targetIndex ? i + 1 : i - 1;
	const newTargetId = index.indexColumnIds[revertIndex];
	undoActions.push(moveIndexColumnAction({
		indexId,
		tableId,
		id,
		targetId: newTargetId
	}));
};
var changeIndexColumnOrderType = (undoActions, { payload: { id, indexId, columnId } }, { collections }) => {
	const indexColumn = query(collections).collection("indexColumnEntities").selectById(id);
	if (!indexColumn) return;
	undoActions.push(changeIndexColumnOrderTypeAction({
		id,
		indexId,
		columnId,
		value: indexColumn.orderType
	}));
};
var indexColumnPushUndoHistoryMap = {
	[ActionType.addIndexColumn]: addIndexColumn,
	[ActionType.removeIndexColumn]: removeIndexColumn,
	[ActionType.moveIndexColumn]: moveIndexColumn,
	[ActionType.changeIndexColumnOrderType]: changeIndexColumnOrderType
};
//#endregion
export { indexColumnPushUndoHistoryMap };
